import type { IAnnotationResponse } from '@1js/cortex-topics-types';
import type { ClientItem } from 'owa-mail-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'addResponseToItem',
    (item: ClientItem, apiResponse: IAnnotationResponse, cacheId: string) => {
        if (!item.topicAnnotationData) {
            item.topicAnnotationData = {
                timestampMap: new Map(),
                dataMap: new Map(),
            };
        }
        item.topicAnnotationData.timestampMap.set(cacheId, Date.now());
        item.topicAnnotationData.dataMap.set(cacheId, apiResponse);
    }
);
